export default __webpack_public_path__ + "static/applying-grid-light-c41df97ab7404feee634bab8256424380295bab7cbeeecf3754e7507032338d7.png";